import { css, html, LitElement, PropertyValues } from "lit";
import { customElement } from "lit/decorators/custom-element.js";
import { sharedStyles } from "../../styles/shared";
import "../../molecules/toolbox";
import { ToolboxItem } from "../../data/toolbox-items";
import { addRouteChangedListener, pushState, removeRouteChangedListener } from "../../util/route-util";
import { ROUTES } from "../../config";
import { ifDefined } from "lit/directives/if-defined.js";
import { dispatchDarkmodeEvent } from "../../util/landing-util";

@customElement("bs-landing-toolbox-page")
class BsLandingToolboxPage extends LitElement {
	static get styles() {
		return [
			sharedStyles,
			css`
				:host {
					--toolbox-section-padding-mobile: 0 var(--space-l);
				}
			`
		];
	}

	private boundRouteChanged = this.routeChanged.bind(this);

	protected firstUpdated(props: PropertyValues) {
		super.firstUpdated(props);
		addRouteChangedListener(this.boundRouteChanged);
		this.updateDarkmode();
	}

	disconnectedCallback() {
		super.disconnectedCallback();
		removeRouteChangedListener(this.boundRouteChanged);
	}

	selectToolboxItem(item: ToolboxItem | undefined) {
		pushState(ROUTES.toolbox(item?.id));
	}

	routeChanged() {
		this.requestUpdate();
		this.updateDarkmode();

		// Scroll to top if a toolbox item is selected
		requestAnimationFrame(() => {
			if (this.getSelectedId() != null) {
				window.scrollTo({ top: 0, behavior: "auto" });
			}
		});
	}

	updateDarkmode() {
		dispatchDarkmodeEvent(this.getSelectedId() != null);
	}

	getSelectedId(): string | undefined {
		return window.location.pathname.split("/")?.[2];
	}

	render() {
		const selectedId = this.getSelectedId();
		return html`
			<bs-toolbox
				selected-id="${ifDefined(selectedId)}"
				@select="${(e: CustomEvent<ToolboxItem | undefined>) => this.selectToolboxItem(e.detail)}"
			></bs-toolbox>
		`;
	}
}
